import React, { useRef, useState, useEffect } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography
} from '@mui/material';
import EnergiesTableContent from "./EnergiesTableContent";
import EnergiesPieChart from "./EnergiesPieChart";
import { formatDate } from '../../../helpers/utils';

function EnergiesOverview({ reportData, reportType, piechartOn, heatmapOn, subReportGroupSelection, handleSubReportGroupSelection }) {

  return (
    reportData.map((singleReport, index) => {
      const month = new Date(singleReport.ReportDate).getMonth() + 1;


      return (
        <Box key={`${index}${singleReport.ReportDate}`} id={`container-${index}-${singleReport.ReportDate}`}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" >
              {reportType === "Month" ?
                //ReportDate to format mm.yyyy for month
                `Month Energy Report ${("0" + month).slice(-2)}.${singleReport.ReportDate.substring(0, 4)}`
                :
                //ReportDate to format dd.mm.yyyy for day report
                `Day Energy Report ${formatDate(singleReport.ReportDate)}`
              }
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: "column", gap: 2 }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <EnergiesTableContent
                singleReport={singleReport}
                reportType={reportType}
                month={month}
                subReportGroupSelection={subReportGroupSelection}
                heatmapOn={heatmapOn}
              />
            </Box>
            {piechartOn && (
              <EnergiesPieChart
                reportData={singleReport}
                subReportGroupSelection={subReportGroupSelection}
              />
            )}
          </Box>
        </Box>
      );
    })
  );
}
export default EnergiesOverview;